

import { OSSNGroupMapping_hardCoded } from './devtemp_ossn_groupmembership'

class OSSNAPI {
    constructor(hostConfig){
        this.site = hostConfig.host;   //this is the real host accessed in production, actually hard coded in MyAppServerComm.js

        this.ossn_devtest = "http://ossn.tinyshare.info:8080"   //hard coded for dev testing

        //ep: endpoints.
        //define in :  C:\inetpub_nlp\wwwroot\python_fp_ossn\app.py
        //deployed on:  ossnapi.tinyshare.info:8080

        this.ep_user_auth       =   this.site + '/oapi/v1.0/user_authenticate'
        this.ep_user_details    =   this.site + '/oapi/v1.0/user_details'
        this.ep_group_post_list =   this.site + '/oapi/v1.0/wall_list_group'
        this.ep_user_add        =   this.site + '/oapi/v1.0/user_add'
    }

    // method:['user_authenticate' | 'user_details' | 'user_add']



    encodeNchain(args){
       //url encode values, then chain together as query string:
       let queryParams = ''
        let encoded_value = ''
        for (let key in args) {
            encoded_value = encodeURIComponent(args[key]);
            queryParams += `&${key}=${encoded_value}`
        }
        return queryParams
    }

    async api_call(method, args){

         //const queryParams = new URLSearchParams(args).toString().replace(/\+/g, '%20');
        const queryParams = this.encodeNchain(args)
        let query_string = 'cmd=' + method
        if(queryParams.length>0){
            query_string += queryParams
        }

        const fetch_url = this.site  + '/oapi/call?' + query_string
        console.log('api_call():' + method)
        return await this.myFetch(fetch_url);
    }


    //2025.6.18 copied api_call_using_post() here from D:\aJJData_D\2022.EtsySellerNotesApp\coreui-free-react-admin-template-main\src\esn_src\services\OSSNAPI.js
    //reason:  "get" call cann't handle increasing parameters (number of registered 

    //2025.3.17 using HTTP "POST" instead of "GET" (so params contain "?" won't cause errors), and 'Content-Type': 'application/json' (so nested data structure is supported)
    // so far "method" supported: in OSSN extendedAPI, 
    // 'wall_add_my',   where an extra arg data_vars = {key:value,...} is passed through POST, as json data.
    //
    //2025.3.19 'application/json' support turns out to be important for some OSSN extendedAPI calls (wall_add_my) when we added support to data_vars which contains nested key/value pairs.
    //2025.3.20 Unify  client => app.py http call, let app.py decide app.py => OSSNAPI call using json or data (both POST). In reality, only OSSN extendedAPI (some) support json.
    // but we're also aware here at client side of the extra args evenual json calls support.

    async api_call_using_post(method, args){

        const fetch_url = this.site + '/oapi/call';  
            //jsoncall:  'json' here indicates app.py will further call some OSSN extendedAPI (we developed) using POST/JSON... to differentiate with '/oapi/call' on app.py to call regular OSSN REST API endpoints.
        const postData = {
            cmd: method,
            ...args  // Spread the arguments into the data object
        };

        console.log('api_call_using_post():', method);
        return await this.myFetchWithOptions(fetch_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                // Add any other required headers here
            },
            body: JSON.stringify(postData)
        });
    }



    async myFetchWithOptions(url,options){
          try {
                const response = await fetch(url,options);
                if (!response.ok) {
                  throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                //console.log(data);
                return data
          } catch (error) {
            console.error(error);
                return {error: 'error'}
          }
    }


    async myFetch(url){
          try {
                const response = await fetch(url);
                if (!response.ok) {
                  throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                //console.log(data);
                return data
          } catch (error) {
            console.error(error);
                return {error: 'error'}
          }
    }

    //https://www.mywebsite.com/api/v1.0/wall_list_group
    async groupListAllPosts(gid, uid){
        const fetch_url = this.ep_group_post_list + `?group_guid=${gid}&guid=${uid}`  // error:  offet / count either one causes error. &offset=0&count=10`
        return await this.myFetch(fetch_url);
    }

    async userAuth(username, password) {
        const fetch_url = this.ep_user_auth + `?&username=${username}&password=${password}`
        return await this.myFetch(fetch_url);
    }

    async userDetails(uid){
        const fetch_url = this.ep_user_details + `?guid=${uid}`
        return await this.myFetch(fetch_url);
    }

    async userDetails2(uid){
        return await this.api_call('user_details', {guid:uid})
    }

    //Add user into system, i.e. register.
/*
            firstname	Yes	string	First name
            lastname	Yes	string	Last name
            email		Yes	string	User Email
            reemail		Yes	string	User email (again for verification)
            gender		Yes	string	Gender (male/female)
            birthdate	Yes	string	dd/mm/yyyy
            username	Yes	string	Username (alphanumeric > 6)
            password	Yes	string	User password (>6)
*/

    async addUser2(args){
        //email, username, password
        return await this.api_call('user_add',args)
    }

    async devTest(){
        const uid = 1
        const ossn_api_key_token = 'b5d449b38dc547fad123332dc577c1c6d18b41500aff965f7a32f65a414d48bb'
        let ossn_api = this.ossn_devtest + '/api/v1.0/user_details'
        const fetch_url = ossn_api + `?guid=${uid}&api_key_token=${ossn_api_key_token}`
        const result =await this.myFetch(fetch_url);
        return result
    }

    //2025.1.26 AFTER long struggle:  'POST' works only with 'Content-Type': 'application/x-www-form-urlencoded'， not 'Content-Type': 'application/json'
    async devTest2(){

        const email = "jjc3561@gmail.com"
        const ossn_api_key_token = 'b5d449b38dc547fad123332dc577c1c6d18b41500aff965f7a32f65a414d48bb'
        let ossn_api = this.ossn_devtest + '/api/v1.0/my_getuid'

        const data_send = {api_key_token: ossn_api_key_token, "email": email}

        try {
                let testData = data_send
                const response = await fetch(ossn_api, {
                                                        method: 'POST',
                                                        headers: {
                                                            'Content-Type': 'application/x-www-form-urlencoded'
                                                        },
                                                        body: this.encodeNchain(data_send)
                                                    }
                );
                if (!response.ok) {
                  throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                console.log(data);
                return data
          } catch (error) {
            console.error(error);
                return {error: 'error'}
          }
    }


    async loadOSSNPostList(ossnGroupAccessCode,pageSize, pageNum){
    // basic OSSN house keeping:  user_guid, group_guid, check once, cache in Redux Store.
    //offset, count

        let group_guid = 21
        const uid = 1

        group_guid = OSSNGroupMapping_hardCoded[ossnGroupAccessCode] ?? 0; // Returns 0 if the property
        if (group_guid === 0){
            alert("Error! group does not exist: " + ossnGroupAccessCode)
            return
        }
        const result = await this.api_call('wall_list_group_my', {group_guid:group_guid, guid:uid})
        return result
    }

   async loadOSSNPostListEx(ossnGroupAccessCode, timeStart, timeEnd){
    // basic OSSN house keeping:  user_guid, group_guid, check once, cache in Redux Store.
    //offset, count

        let group_guid = 21
        const uid = 1

        group_guid = OSSNGroupMapping_hardCoded[ossnGroupAccessCode] ?? 0; // Returns 0 if the property
        if (group_guid === 0){
            alert("Error! group does not exist: " + ossnGroupAccessCode)
            return
        }

        const args = {group_guid:group_guid, guid:uid}

       if(timeStart){
            args.time_start = timeStart
        }

       if(timeEnd){
            args.time_end = timeEnd
        }

        const result = await this.api_call('wall_list_group_my',args)
        return result
    }
 
    async createIBGAttendanceOSSNPost(attendanceGroupCodeName, poster_guid, text){
    // basic OSSN house keeping:  user_guid, group_guid, check once, cache in Redux Store.

        let group_guid = 9
        group_guid = OSSNGroupMapping_hardCoded[attendanceGroupCodeName]

        //2025.6.26 switch to api_call_using_post() since "text" is too long for URL parameters to handle.
        const result = await this.api_call_using_post('wall_add', { owner_guid: group_guid, poster_guid: poster_guid, type: "group", post:text})
        //2025.2.9 lesson learned: 1) source code is the only truth;  2) OSSN REST API doc often wrong;  3) REST API parameter naming very inconsistent.

        return result
    }

    async updateIBGAttendanceOSSNPost(post_guid, poster_guid, text){
    // basic OSSN house keeping:  user_guid, group_guid, check once, cache in Redux Store.

    //offset, count

        //2025.6.18 switch to api_call_using_post() since "text" is too long for URL parameters to handle.
        const result = await this.api_call_using_post('post/edit', {post_guid:post_guid, uguid: poster_guid, text:text})
        return result
    }

   async deleteIBGAttendanceOSSNPost(post_guid, poster_guid){

        const result = await this.api_call('wall_delete', { post_guid: post_guid, guid: poster_guid})
        return result
    }

    async createIBGChatroomOSSNPost(chatroomCodename, poster_guid, text){
        //const group_guid = 21
        // an IBG chatroom is implemented as an OSSN wall-group, so chatroom_id = group_guid.

        const group_guid = OSSNGroupMapping_hardCoded[chatroomCodename]
        const result = await this.api_call('wall_add', { owner_guid: group_guid, poster_guid: poster_guid, type: "group", post:text})
        //2025.2.9 lesson learned: 1) source code is the only truth;  2) OSSN REST API doc often wrong;  3) REST API parameter naming very inconsistent.
        return result
    }

   async updateIBGChatroomOSSNPost(post_guid, poster_guid, text){
    // basic OSSN house keeping:  user_guid, group_guid, check once, cache in Redux Store.

    //offset, count
        const result = await this.api_call('post/edit', {post_guid:post_guid, uguid: poster_guid, text:text})
        return result
    }


    async deleteIBGChatroomOSSNPost(post_guid, poster_guid){
        const result = await this.api_call('wall_delete', { post_guid: post_guid, guid: poster_guid})
        //2025.2.9 lesson learned: 1) source code is the only truth;  2) OSSN REST API doc often wrong;  3) REST API parameter naming very inconsistent.
        return result
    }


    async createIBGChatroomOSSNPostReply(post_guid, commenter_guid, text){
        const result = await this.api_call('comment_add', { subject_guid: post_guid, uguid: commenter_guid, type: "post", comment:text})
        return result
    }

   async updateIBGChatroomOSSNPostReply(reply_guid, text){
    //offset, count
        const result = await this.api_call('comment_edit', {guid:reply_guid, comment:text})
        return result
    }

    async deleteIBGChatroomOSSNPostReply(reply_guid, replyer_guid){
        const result = await this.api_call('comment_delete', { id: reply_guid, guid: replyer_guid})
        //2025.2.9 lesson learned: 1) source code is the only truth;  2) OSSN REST API doc often wrong;  3) REST API parameter naming very inconsistent.
        return result
    }


    async loadRepliesOfOnePostOSSN(parentPostId, user_guid){
        //offset, limit
        const result = await this.api_call('comments_list', { guid: parentPostId, uguid: user_guid, type: 'post'})
        return result
    }

    async loadOSSNIBGPlayerList(groupName, offset=1){

        const group_guid = OSSNGroupMapping_hardCoded[groupName]
        const uid = 1
        const result = await this.api_call('wall_list_group_my', {group_guid:group_guid, guid:uid, offset:offset});
        return result
    }

    //each player data is stored as one OSSN post, in group "Tier1IBG_Playerlist"
   async updateOSSNIBGPlayer(ossn_post_guid, text){
        const uid = 1
        const result = await this.api_call('post/edit', {post_guid:ossn_post_guid, uguid: uid, text:text})
        return result
    }

    //2025.3.3, when trying to create players added in AttendancePage.
    //already,  C:\inetpub_nlp\wwwroot\python_fp_ossn\CmdUtilities\BatchEditOSSNPosts.py, used python to create existing players on OSSN server
/*      'cmd': "wall_add",
        'ossnserver': 'ossn',
        'owner_guid':  60,     #OSSN group:  Tier1IBG_Playerlist
        'poster_guid': 1,  #
        'type': 'group',
        'post': text,    */

   async createOSSNIBGPlayer(playerlistCodename, text){
        const uid = 1                        // hard coded OSSN.tinyshare.info  admin account.
        //const IBGPlayerListGroup_guid = 60   // hard coded OSSN.tinyshare.info::Tier1IBG_Playerlist  group.


        let IBGPlayerListGroup_guid = 60
        let PlayerLisGroup = playerlistCodename  //'playerlisting_nbtc'
        IBGPlayerListGroup_guid = OSSNGroupMapping_hardCoded[PlayerLisGroup]


        const args = {
                ossnserver:     'ossn',
                owner_guid:     IBGPlayerListGroup_guid,
                poster_guid:    uid,
                type:           'group',
                post:           text
        }
        const result = await this.api_call('wall_add', args)
        return result
    }


};

export { OSSNAPI}